module.exports = __webpack_public_path__ + "static/media/sorting.7743f77d.svg";